import { Action, Card } from 'corso-admin-ui';
import { useConfigSettings } from '~/hooks/useConfigSettings';
import { useStoreId } from '~/providers/StoreUserProvider';
import CheckoutWidgetPreview from './CheckoutWidgetPreview';

function useModalValues() {
  const { data } = useConfigSettings(
    ({ shippingProtection }) => shippingProtection,
  );

  if (!data?.widgetConfig) return null;

  const { widgetConfig, isShippingLineProtectionOffered } = data;

  const isVariantProtection =
    widgetConfig.checkoutPlus.checkoutAction === 'addVariantToCart';

  const isShippingPlusMode =
    !isVariantProtection && isShippingLineProtectionOffered;

  const label = isShippingPlusMode
    ? widgetConfig.shippingPlus.label
    : widgetConfig.checkoutPlus.productCheckoutExtensionTitle;

  const description = isShippingPlusMode
    ? widgetConfig.shippingPlus.description
    : widgetConfig.checkoutPlus.productCheckoutExtensionDescription;

  return {
    showCheckbox: !isShippingPlusMode,
    modal: widgetConfig.modal,
    label,
    description: description ?? 'For lost, damaged or stolen packages.',
  };
}

export function CheckoutWidgetCard({ returnTo }: { returnTo: string }) {
  const storeId = useStoreId();
  const values = useModalValues();
  if (!values) return null;
  const { label, description, modal, showCheckbox } = values;

  return (
    <Card>
      <Card.Line>
        <Card.Heading> Checkout Widget</Card.Heading>
        <Action
          icon="edit"
          variant="ghost"
          accessibilityLabel="Edit Widget"
          to={`/${storeId}/settings/checkout-widget?returnTo=${encodeURIComponent(
            returnTo,
          )}`}
        />
      </Card.Line>

      <CheckoutWidgetPreview
        showCheckbox={showCheckbox}
        label={label}
        description={description}
        modal={modal}
      />
    </Card>
  );
}
